import PropTypes from 'prop-types';
import Link from 'client/components/aria/Link/Link';

const BackLink = ({ onClick, children, ...props }) => {
    return (
        <Link
            className="govuk-back-link govuk-!-font-weight-regular"
            onClick={onClick}
            {...props}
        >
            {children}
        </Link>
    );
};

BackLink.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

export default BackLink;
